if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.radios = document.querySelector("variant-radios");
        this.cartDrawer = document.querySelector("cart-drawer");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            cartUpdate(response);
            const cartDrawerSummary = document.querySelector(
              "cart-drawer .header__icon"
            );
            if (!cartDrawerSummary.parentNode.hasAttribute("open")) {
              cartDrawerSummary.click();
            }

            document.dispatchEvent(new CustomEvent("product:addtocart"));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            if (this.radios) {
              this.radios.renderProductInfo();
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class ProductThumbnail extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }
  onClick() {
    const myEl = event.target
      .closest("product-thumbnail")
      .getAttribute("data-main-media");
    if (!myEl) return;
    const mySection = document.querySelector(`#${myEl}`);
    const headerOffset = 100;
    const mySectionPosition = mySection.getBoundingClientRect().top;
    const offsetPosition =
      mySectionPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
}

customElements.define("product-thumbnail", ProductThumbnail);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.currentVariant = window.initialVariant || false;
    this.productId = window.productJSON.id;
    this.updateAvailability();
    // this.backInStock();
    // this.onVariantChange();
  }

  onVariantChange(event) {
    if(event.target.name === 'Color') {
      this.renderNewColor();
      return;
    }
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    // this.updatePickupAvailability();
    this.updateAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      console.log("no variant");
      this.toggleAddButton(true, "", true);
      // this.setUnavailable();
      this.renderNewColor();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSizeChart();
      // this.toggleBIS();
    }
    // this.backInStock();
  }

  updateSizeChart() {}

  backInStock() {
    const bisWrapper = document.querySelector(".BIS_wrapper");
    bisWrapper.nextElementSibling.classList.add("hidden");
    if (!bisWrapper) return;
    if (this.currentVariant.available) {
      bisWrapper.style.display = "none";
    } else {
      bisWrapper.style.display = "block";
    }
    const bisTrigger = bisWrapper.querySelector("#BIS_trigger");
    bisTrigger.addEventListener("click", () => {
      const mainBis = bisWrapper.nextElementSibling.querySelector('button');
      mainBis.click();
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    console.log("updateMedia");

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.currentVariant.productUrl}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateAvailability() {
    const colorIndex = window.productJSON.options.indexOf("Color");
    const sizeIndex = window.productJSON.options.indexOf("Size");

    // const currentColor = window.decoyVariant ? window.decoyVariant.options[colorIndex] : this.currentVariant.options[colorIndex];
    const currentColor = this.currentVariant ? this.currentVariant.options[colorIndex] : window.decoyVariant.options[colorIndex];


    window.productJSON.variants.forEach((variant) => {
      if (variant.options[colorIndex] !== currentColor) return true;
      const mySizeEl = this.querySelector(
        `input[value="${variant.options[sizeIndex]}"]`
      );
      if (!mySizeEl) return;
      variant.available
        ? mySizeEl.parentNode.classList.remove("soldout")
        : mySizeEl.parentNode.classList.add("soldout");
      const sizeChartInput = document.querySelector(
        `.size-chart__input[value="${variant.options[sizeIndex]}"]`
      );
      if (sizeChartInput) {
        if (variant.available) {
          sizeChartInput.closest("tr").classList.remove("soldout");
          sizeChartInput.classList.remove("soldout");
        } else {
          sizeChartInput.closest("tr").classList.add("soldout");
          sizeChartInput.classList.add("soldout");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderNewColor() {
    const selectedColor = this.querySelector('input[name="Color"]:checked');
    console.log(selectedColor)
    if (!selectedColor) return;
    const colorName = selectedColor.value;
    let foundOne = false;
    let colorUrl = false;
    let newVariant = false;
    window.productJSON.variants.forEach((variant) => {
      if (variant.options.indexOf(colorName) > -1 && !foundOne) {
        colorUrl = variant.productUrl;
        foundOne = true;
        if(variant.available) {
          newVariant = variant;
          window.decoyVariant = variant;
        }
      }
    });
    if (!colorUrl) return;
    window.location.href = colorUrl;
    return;

    fetch(`${colorUrl}`)
      .then((response) => response.text())
      .then((responseText) => {
        var elementsToUpdate = [
          ".product__price-block",
          ".limited-supply__wrapper",
          '.variant-radios__wrapper[data-option="Color"] .current-value',
          ".buy-2--wrapper",
        ];

        var extraElements = [
          ".product__media-wrapper",
          ".product__description",
          ".product__title",
          "#product-accordion--fit-care .accordion__content",
          ".product-recommendations__wrapper",
          "#buy-buttons__notes",
          ".size-chart__product-image",
          ".size-chart__product-title",
        ];

        const allElements =
          this.productId !== newVariant.productId
            ? elementsToUpdate.concat(extraElements)
            : elementsToUpdate;
        const html = new DOMParser().parseFromString(responseText, "text/html");

        allElements.forEach((el) => {
          const destination = document.querySelector(el);
          const source = html.querySelector(el);
          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        playPauseVideo();
        lazyImages();
        initializeSwipers();
        this.updateAvailability();

        this.productId = newVariant.productId;
        // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
    if (!newVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${newVariant.productUrl}`);
  }

  renderProductInfo() {
    fetch(`${this.currentVariant.productUrl}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        var elementsToUpdate = [
          ".product__price-block",
          ".limited-supply__wrapper",
          '.variant-radios__wrapper[data-option="Color"] .current-value',
          '.variant-radios__wrapper[data-option="Size"] .current-value',
          ".buy-2--wrapper",
        ];

        var extraElements = [
          ".product__media-wrapper",
          ".product__description",
          // ".variant-radios__wrapper[data-option='Size']",
          ".product__title",
          "#product-accordion--fit-care .accordion__content",
          ".product-recommendations__wrapper",
          "#buy-buttons__notes",
          ".size-chart__product-image",
          ".size-chart__product-title",
        ];

        const allElements =
          this.productId !== this.currentVariant.productId
            ? elementsToUpdate.concat(extraElements)
            : elementsToUpdate;
        const html = new DOMParser().parseFromString(responseText, "text/html");

        allElements.forEach((el) => {
          const destination = document.querySelector(el);
          const source = html.querySelector(el);
          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        playPauseVideo();
        lazyImages();
        initializeSwipers();
        this.updateAvailability();


        this.productId = this.currentVariant.productId;
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }
  toggleBIS() {
    const bis = document.querySelector(".BIS_wrapper");
    const bisButton = document.querySelector("#BIS_trigger");
    if(this.currentVariant.available) {
      bis.style.display = 'none';
    } else {
      bisButton.setAttribute('data-variant-id', this.currentVariant.id);
      bis.style.display = 'block';
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || window.productJSON.variants;
    return this.variantData;
  }
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const checked = Array.from(
      this.querySelectorAll('.variant-radio input[type="radio"]:checked'),
      (e) => e.value
    );
    this.options = checked;
  }
}

const getSwatches = () => {
  console.log("getSwatches");
};

sizeChartEvents = () => {
  console.log("sizeChartEvents");
  const sizeChartInputs = document.querySelectorAll(".size-chart__input");
  const sizeChartSubmit = document.getElementById("size-guide__add-button");
  const mainSubmit = document.querySelector(".product-form__submit");
  const formEl = document.querySelector("product-form");
  sizeChartInputs.forEach((input) => {
    input.addEventListener("change", (e) => {
      const mySize = e.target.value;
      let productSize = document.querySelector(
        `.variant-radios__wrapper[data-option="Size"] input[value="${mySize}"]`
      );
      if (productSize) {
        productSize.checked = true;
        sizeChartSubmit.disabled = false;
        productSize.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });

  sizeChartSubmit.addEventListener("click", (event) => {
    event.preventDefault();
    formEl.form.dispatchEvent(new Event("submit", { bubbles: true }));
    document
      .querySelector("#ModalClose-size-guide")
      .dispatchEvent(new Event("click", { bubbles: true }));
  });
};

const buildSizeChart = () => {
  console.log("buildSizeChart");
  const sizeChart = document.querySelector("#PopupModal-size-guide");
  if (!sizeChart) return;
  const sizeChartTable = sizeChart.querySelector("table");
  const sizeChartTableTr = sizeChartTable.querySelectorAll("tr");
  sizeChartTableTr.forEach((tr, i) => {
    if (i === 0) return true;
    let firstTd = tr.querySelector("td:first-child");
    let secondTd = tr.querySelector("td:nth-child(2)");
    let sizeChartRadioEl = document.createElement("div");
    sizeChartRadioEl.classList.add("size-chart-radio");
    sizeChartRadioEl.innerHTML = `<input class="size-chart__input" id="size-chart-size--${i}" type="radio" name="size-chart--size" value="${secondTd.textContent}">
    <label class="size-chart__label" for="size-chart-size--${i}">&nbsp;<span class="visually-hidden">${secondTd.textContent}</span></label>`;
    firstTd.appendChild(sizeChartRadioEl);
  });
  sizeChartEvents();
};


(function () {
  console.log("set it all up");
  const productStyle = window.productJSON.title
    .split(" - ")[0]
    .replace("#", "");

  const colorIndex = window.productJSON.options.indexOf("Color");
  if (colorIndex === -1) {
    customElements.define("variant-selects", VariantSelects);
    customElements.define("variant-radios", VariantRadios);
  }
  if (window.productJSON.id === 9553430031) {
    document.querySelector(".product-form__submit").removeAttribute("disabled");
  }

  const productColor = window.productJSON.variants[0].options[colorIndex];
  const formId = document
    .querySelector(".product-form form")
    .getAttribute("id");
  const colorRadios = document.querySelector(
    '.variant-radios__wrapper[data-option="Color"] .variant-radios'
  );

  fetch(`/search?q=${productStyle.split(" ").join("+")}&type=product&view=api`)
    .then((response) => response.json())
    .then((data) => {
      data.forEach((item, i) => {
        //       if(item.title.indexOf(' - ') === -1) return true;

        if (item.type !== window.productJSON.type) return true;

        const itemColorIndex = item.options.indexOf("Color");
        if (itemColorIndex === -1) return true;

        const itemColor = item.variants[0].options[itemColorIndex];

        if (productColor === itemColor) return true;

        const itemStyle = item.title;
        if (itemStyle != productStyle) return true;

        const newColorElement = document.createElement("div");
        newColorElement.classList.add("variant-radio");
        newColorElement.innerHTML = `<div class="variant-radio" data-tooltip="${itemColor}">
        <input type="radio" id="new-color-${itemColor}"
               name="Color"
               value="${itemColor}"
               form="${formId}"
               >
		<label for="new-color-${itemColor}">${itemColor}</label>
      </div>`;
        colorRadios.appendChild(newColorElement);

        item.variants.forEach((variant) => {
          variant.productUrl = `/products/${item.handle}`;
          variant.productId = item.id;
          window.productJSON.variants.push(variant);
        });
      });
      customElements.define("variant-selects", VariantSelects);
      customElements.define("variant-radios", VariantRadios);
      getSwatches();
    })
    .catch((error) => console.log(error));
  buildSizeChart();
})();
